/**
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2021. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 */
'use strict';

/*
 * Safely loads HTML-escaped JSON payloads in script tags that were added to the page to send data from the server
 * to the client during page load. e.g.
 *   <script id="mydata">{&quot;property&quot;: &quot;value&quot;}</script>
 *
 * const jsonPayload = require('./json-payload');
 * const data = jsonPayload.get('mydata');
 * // data is an object parsed from the json
 */
exports.get = function (id) {
  // html-encoded json script tags do not come out decoded with .textContent, so we first transfer to an HTML
  // element then get textContent to decode it. Using textarea prevents any inadvertent execution of
  // javascript (XSS)
  var textArea = document.createElement('textarea'),
    scriptElem = document.getElementById(id);
  textArea.innerHTML = scriptElem.innerHTML;
  return JSON.parse(textArea.textContent);
};